import { Environments } from './interfaces';

export const onEnvironment = (environment: Environments[] | Environments) => {
	if (typeof environment === 'string') {
		return import.meta.env.VITE_ENVIRONMENT === environment;
	}

	return environment.some((env) => env === import.meta.env.VITE_ENVIRONMENT);
};
